// extracted by mini-css-extract-plugin
export default {"extra-bottom-spacing":"_2h3ZM","extraBottomSpacing":"_2h3ZM","label-wrapper":"_1_Hp8","labelWrapper":"_1_Hp8","details-wrapper":"_1Bfid","detailsWrapper":"_1Bfid"};